export const PLANES = {
  basic:    { web: false, whatsapp: false, tokens: false, conversaciones: false, social: false, calendario: false },
  web:      { web: true,  whatsapp: false, tokens: true,  conversaciones: true,  social: false, calendario: true  },
  whatsapp: { web: false, whatsapp: true,  tokens: true,  conversaciones: true,  social: false, calendario: true  },
  completo: { web: true,  whatsapp: true,  tokens: true,  conversaciones: true,  social: false, calendario: true  },
  web_anual:      { web: true,  whatsapp: false, tokens: true, conversaciones: true,  social: false, calendario: true },
  whatsapp_anual: { web: false, whatsapp: true,  tokens: true, conversaciones: true,  social: false, calendario: true },
  completo_anual: { web: true,  whatsapp: true,  tokens: true, conversaciones: true,  social: false, calendario: true },
  web_social:           { web: true,  whatsapp: false, tokens: true, conversaciones: true, social: true, calendario: true },
  whatsapp_social:      { web: false, whatsapp: true,  tokens: true, conversaciones: true, social: true, calendario: true },
  completo_social:      { web: true,  whatsapp: true,  tokens: true, conversaciones: true, social: true, calendario: true },
  web_social_anual:     { web: true,  whatsapp: false, tokens: true, conversaciones: true, social: true, calendario: true },
  whatsapp_social_anual:{ web: false, whatsapp: true,  tokens: true, conversaciones: true, social: true, calendario: true },
  completo_social_anual:{ web: true,  whatsapp: true,  tokens: true, conversaciones: true, social: true, calendario: true },
  presencia:         { web: false, whatsapp: false, tokens: true, conversaciones: false, social: true, seo: true, calendario: false, leads: false },
  presencia_anual:   { web: false, whatsapp: false, tokens: true, conversaciones: false, social: true, seo: true, calendario: false, leads: false },
  conversacion:      { web: true, whatsapp: true,  tokens: true, conversaciones: true, social: false, seo: false, calendario: true,  leads: true },
  conversacion_anual:{ web: true, whatsapp: true,  tokens: true, conversaciones: true, social: false, seo: false, calendario: true,  leads: true },
  autonomo:          { web: true, whatsapp: true,  tokens: true, conversaciones: true, social: true, seo: true, calendario: true,  leads: true },
  autonomo_anual:    { web: true, whatsapp: true,  tokens: true, conversaciones: true, social: true, seo: true, calendario: true,  leads: true },
};

export function getPermisos(plan) {
  return PLANES[plan] || PLANES['basic'];
}

export function PlanRequerido({ onUpgrade }) {
  return (
    <div style={{
      padding: '48px 24px', textAlign: 'center',
      background: 'var(--bg2)', borderRadius: '10px',
      border: '1px solid var(--border)', margin: '24px'
    }}>
      <div style={{ fontSize: '32px', marginBottom: '16px' }}>🔒</div>
      <div style={{
        fontFamily: 'var(--font-display)', fontSize: '18px',
        fontWeight: 700, marginBottom: '10px', color: 'var(--text)'
      }}>
        Función no disponible en tu plan
      </div>
      <div style={{ fontSize: '13px', color: 'var(--text2)', marginBottom: '24px' }}>
        Actualiza tu plan para acceder a esta función.
      </div>
      <button className="btn btn-primary" onClick={onUpgrade}>
        Ver planes →
      </button>
    </div>
  );
}